import { JSX } from 'react';

import classNames from 'classnames';

import styles from './VerticalTable.module.scss';
import { TVerticalTableProps } from './VerticalTable.types';
import { VerticalTableBody } from './components';

export const VerticalTable = <T,>({
	columns,
	dataSource,
	rowKey,
	className,
	style,
	onColumn,
}: TVerticalTableProps<T>): JSX.Element => {
	return (
		<div className={classNames(styles['verticalTable'], className)} style={style}>
			<VerticalTableBody
				columns={columns}
				dataSource={dataSource}
				rowKey={rowKey}
				onColumn={onColumn}
			/>
		</div>
	);
};
